import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import { firebaseStateReducer } from "react-redux-firebase";
import userSettings from "../reducers/userSettings.reducer";
import feed from "../reducers/feed.reducer";
import createEditPost from "./createEditPost.reducer";
import userSetup from "../reducers/userSetup.reducer";
import createEditCorrection from "../reducers/createEditCorrection.reducer";
import userProfile from "../reducers/userProfile.reducer";
import editProfile from "../reducers/editProfile.reducer";
import viewPost from "../reducers/viewPost.reducer";
import postActionSnackbar from "../reducers/postActionSnackbar.reducer";
import notifications from "../reducers/notifications.reducer";
import feedback from "../reducers/feedback.reducer";

const reducers = combineReducers({
    router: routerReducer,
    firebase: firebaseStateReducer,
    userSettings,
    feed,
    createEditPost,
    userSetup,
    createEditCorrection,
    userProfile,
    editProfile,
    viewPost,
    postActionSnackbar,
    notifications,
    feedback
});

export default reducers;



// WEBPACK FOOTER //
// ./src/reducers/reducers.js